import React, { useEffect, useState } from "react";
import { Column, MasterDetail, GroupItem, Summary, TotalItem } from "devextreme-react/data-grid";
import { LVGridCarga } from "../../Componentes/Basicos/LVGridCarga";
import ComboAbmEexProveedores from "../Compuestos/Combos/ComboAbmEexProveedores";
import LVNumberBoxDocumento from "../Compuestos/Complejos/LVNumberBoxDocumento";
import { CheckBox, DateBox, TextBox } from "devextreme-react";
import { NumberBox } from "devextreme-react";
import ComboAbmConMonedas from "../Compuestos/Combos/ComboAbmConMonedas";
import LVSelectorRetencionesCompra from "../Selectores/LVSelectorRetencionesCompra";
import LVButtonAccion from "../Basicos/LVButtonAccion";
import { function_COM_DocsCompra_Cabecera_ListarPorPagar } from "neftis7_apicaller/src/funciones/COM/DocsCompra/COM_DocsCompra_Cabecera";
import { FormateoFechaPara_yyyyMMdd, FormateoFechaPara_yyyyMMdd_HHmmss } from "neftis7_apicaller/src/funciones/Varios";
import LVFormasDePago from "../Compuestos/Complejos/Operaciones/LVFormasDePago";
import { function_ABM_IMP_PuntosFiscales_LeerPorTerminal } from "neftis7_apicaller/src/funciones/ABM/IMP/ABM_IMP_PuntosFiscales";
import { function_COM_Pagos_Generar_JSON, function_COM_Pagos_Cabecera_Insertar } from "neftis7_apicaller/src/funciones/COM/Pagos/COM_Pagos_Cabecera";
import { function_ABM_CON_Monedas_Leer } from "neftis7_apicaller/src/funciones/ABM/CONT/ABM_CON_Monedas";

const COM_Pagos = (props) => {
  const [loading, setLoading] = useState(true);
  const [datos, setDatos] = useState([]);
  const [data, setData] = useState([]);
  const [TituloBoton, setTituloBoton] = useState("");
  const [accionBoton, setAccionBoton] = useState("");
  const [idPagoAsignado, setIdPagoAsignado] = useState(0);
  const [codigoMoneda, setCodigoMoneda] = useState("PA");
  const [cotizacion, setCotizacion] = useState(1);
  const [codigoMonedaReferente, setCodigoMonedaReferente] = useState("");
  const { Varios: { ObtieneParametros, TratamientoDeVariableBoolean } } = require('neftis7_apicaller');
  const { ABM_EEX_Proveedores: { function_ABM_EEX_Proveedores_Leer } } = require('neftis7_apicaller');
  const [idProveedorSeleccionado, setIdProveedorSeleccionado] = useState(0);
  const [idProveedor, setIdProveedor] = useState(0);
  const [fecha, setFecha] = useState(new Date());
  const [idTipo, setIdTipo] = useState(3); //PREDEFINIDO PARA TODA LA PAGINA
  const [idTipoPago, setIdTipoPago] = useState(1);
  const [datosDocumento, setDatosDocumento] = useState([]);
  const [datosImpuestos, setDatosImpuestos] = useState([]);
  const [datosConceptoObservaciones, setDatosConceptoObservaciones] = useState([]);
  const [datosFormasPago, setDatosFormasPago] = useState([]);
  const [showPopupRetenciones, setShowPopupRetenciones] = useState(false);
  const [importeRetencionesTotal, setImporteRetencionesTotal] = useState(0);
  const [importeEnFormasDePagoTotal, setImporteEnFormasDePagoTotal] = useState(0);
  const [valoresNumberBox, setValoresNumberBox] = useState({});
  const [totalEnDocumentos, setTotalEnDocumentos] = useState(0);
  const [totalEnImpuestos, setTotalEnImpuestos] = useState(0);
  const [cantidadDeProveedores, setCantidadDeProveedores] = useState(0);
  const [cierreEnProceso, setCierreEnProceso] = useState(false);
  const [esPagoDeAnticipo, setEsPagoDeAnticipo] = useState(false);

  const recalcularTotalEnDocumentos = (nuevosValores) => {
    let total = 0;
    setIdProveedor(0)
    const proveedoresConValor = new Set();

    data.forEach((row) => {
      const valorImpPagar = nuevosValores[row.IdDocCompra];
      if (valorImpPagar > 0) {
        if ([2, 12, 22, 32, 42, 52, 62, 72, 82, 92].includes(row.IdTipoDocCompra)) {
          total -= valorImpPagar; // Restar si es de los tipos especificados
        } else {
          total += valorImpPagar; // Sumar en los demás casos
        }

        proveedoresConValor.add(row.IdProveedor);
        setIdProveedor(row.IdProveedor)
      }
    });

    setCantidadDeProveedores(proveedoresConValor.size)
    setTotalEnDocumentos(total);
  };

  const agruparDocumentosPorProveedor = () => {
    const agrupados = {};
    const relacionesDocsCompraPagos = [];

    data.forEach((row) => {
      const valorImpPagar = valoresNumberBox[row.IdDocCompra];
      if (valorImpPagar > 0) {  // Solo incluir si tiene valor en Imp.Pagar
        if (!agrupados[row.IdProveedor]) {
          agrupados[row.IdProveedor] = [];
        }
        agrupados[row.IdProveedor].push({ ...row, valorImpPagar });

        // Crear el objeto para relacionesDocsCompraPagos
        relacionesDocsCompraPagos.push({
          IdDocCompra: row.IdDocCompra,
          Importe: valorImpPagar,
          IdTipoDocCompra: row.IdTipoDocCompra,
          CodigoCompania: localStorage.getItem("CodigoCompania"),
          CodigoEmpresa: localStorage.getItem("CodigoEmpresa"),
          CodigoPlanta: localStorage.getItem("CodigoPlanta"),
          CodigoPlantaCompra: localStorage.getItem("CodigoPlanta"),
          CodigoPlantaPago: localStorage.getItem("CodigoPlanta")
        });
      }
    });

    return { agrupados, relacionesDocsCompraPagos };
  };

  const handleValueChange = (id, nuevoValor) => {
    setValoresNumberBox((prev) => {
      const nuevosValores = { ...prev, [id]: nuevoValor }; // Actualiza el valor del NumberBox según el ID de la fila

      recalcularTotalEnDocumentos(nuevosValores);
      return nuevosValores;
    });
  };

  const handleOnValueChange_Moneda = async (e) => {
    if (e.value && e.value != "") {
      setCodigoMoneda(e.value)
      const resultMoneda = await function_ABM_CON_Monedas_Leer(e.value)

      setCotizacion(resultMoneda.data[0].Cotizacion)
    } else {
      setCodigoMoneda("")
      setCotizacion(0)
    }
  };

  const handleOnClick_Retenciones = (e) => {
    setShowPopupRetenciones(true)
  }

  const handleClose_Retenciones = () => {
    setShowPopupRetenciones(false)
  };

  const handleConfirmRetenciones = (dataImpuestos) => {
    if (dataImpuestos) {
      setShowPopupRetenciones(false)
      setDatosImpuestos(dataImpuestos)
    } else {
      setShowPopupRetenciones(false)
    }
  };

  const handleOnClick_Asiento = (e) => {

  }

  const handleOnClick_Costeo = (e) => {

  }

  const handleOnClick_Guardar = async (e) => {
    try {
      if (cierreEnProceso) return; // si ya está ejecutando, no hace nada
      setCierreEnProceso(true);

      if (esPagoDeAnticipo) {
        if (!idProveedorSeleccionado || idProveedorSeleccionado < 1) {
          alert("Debe seleccionar un Proveedor.");
          return;
        }

        let datosDocumentoNumeroActual = datosDocumento.numero;
        let datosDocumentoNuevoNumero = datosDocumentoNumeroActual;

        let datosFormasPagoModificados = datosFormasPago.map((formaPago, index) => ({
          ...formaPago
        }));

        datosFormasPagoModificados = datosFormasPagoModificados.map(item => {
          Object.keys(item).forEach(key => {
            if (key.startsWith("Fecha") && item[key]) {
              item[key] = FormateoFechaPara_yyyyMMdd(new Date(item[key]));
            }
          });

          if (item.IdAnticipoCompra > 0) {
            item.IdAnticipo = item.IdAnticipoCompra;
          }

          return item;
        });

        const numeroFantasiaModificado = `${datosDocumento.codigoPuntoVenta.toString().padStart(4, '0')}-${datosDocumentoNuevoNumero.toString().padStart(8, '0')}`;

        const JSON = await function_COM_Pagos_Generar_JSON(
          0,
          FormateoFechaPara_yyyyMMdd_HHmmss(fecha),
          idProveedorSeleccionado,
          numeroFantasiaModificado,
          datosDocumento.codigoPuntoVenta,
          datosDocumentoNuevoNumero,
          codigoMoneda,
          cotizacion,
          datosConceptoObservaciones.observaciones,
          0,
          0,
          datosFormasPagoModificados,
          datosImpuestos,
          [],
          [],
          [] // Ajustar si se necesitan más datos
        );

        if (esPagoDeAnticipo) {
          const totalImporteFormasDePago = datosFormasPagoModificados.reduce((total, detalle) => total + detalle.Importe, 0);
          const totalImporteImpuestos = datosImpuestos.reduce((total, detalle) => total + detalle.Importe, 0);
          const totalImporteTotalAPagarPostImpuestos = totalImporteFormasDePago - totalImporteImpuestos;
          JSON.ImporteTotalAPagarPostImpuestos = totalImporteTotalAPagarPostImpuestos
          JSON.ImporteTotalAPagar = totalImporteTotalAPagarPostImpuestos
          JSON.ImporteTotalPago = totalImporteTotalAPagarPostImpuestos
        }

        const PagoCreado = await function_COM_Pagos_Cabecera_Insertar(JSON, esPagoDeAnticipo, false)

        alert("Se ha generado el Pago ID: " + PagoCreado.data.codigoGenerado + " - Documento: " + numeroFantasiaModificado)
      }
      else {
        let DebeCrearAnticipo = false;

        const datosModificadores = await ObtieneParametros();
        const resultGlobalToleranciaDeRedondeoEnOperaciones = datosModificadores.GlobalToleranciaDeRedondeoEnOperaciones

        let Diferencia = totalEnDocumentos - (importeEnFormasDePagoTotal + totalEnImpuestos)
        if (Diferencia > resultGlobalToleranciaDeRedondeoEnOperaciones) {
          alert("La sumatoria en Formas de Pago ($" + importeEnFormasDePagoTotal + ") no alcanza para igualar a la sumatoria en Documentos de Compra ($" + totalEnDocumentos + ") menos sus retenciones ($" + totalEnImpuestos + ").");
          return;
        }

        if (cantidadDeProveedores > 1 && datosFormasPago.length > 1) {
          alert("No puede agregar múltiples formas de pago si los Documentos seleccionados pertenecen a más de un Proveedor.");
          return;
        }

        if (cantidadDeProveedores > 1 && importeEnFormasDePagoTotal + totalEnImpuestos > totalEnDocumentos) {
          alert("La sumatoria en Formas de Pago ($" + importeEnFormasDePagoTotal + ") es mayor a a la sumatoria de Documentos de Compra ($" + totalEnDocumentos + ") menos sus retenciones ($" + totalEnImpuestos + ") y han sido seleccionados multiples Proveedores. No se puede continuar ya que no se podría determinar para quien es el Anticipo que se debe generar.");
          return;
        }

        if (importeEnFormasDePagoTotal + totalEnImpuestos > totalEnDocumentos) {
          const generarAnticipo = window.confirm(
            `El importe total en Formas de Pago ($${importeEnFormasDePagoTotal}) supera el total de los Documentos seleccionados ($${totalEnDocumentos}) menos sus retenciones ($${totalEnImpuestos}).\n` +
            `¿Desea generar un anticipo por la diferencia de $${(importeEnFormasDePagoTotal + totalEnImpuestos - totalEnDocumentos).toFixed(2)}?`
          );

          if (!generarAnticipo) {
            alert("Operación cancelada. No se generará ningún Pago.");
            return;
          }
          else {
            DebeCrearAnticipo = true;
          }
        }

        if (cantidadDeProveedores > 1 && DebeCrearAnticipo) {
          alert("No puede generar anticipos si los Documentos seleccionados pertenecen a más de un Proveedor.");
          return;
        }

        const { agrupados, relacionesDocsCompraPagos } = agruparDocumentosPorProveedor(); // Obtener documentos agrupados y el JSON relacionesDocsCompraPagos
        let datosDocumentoNumeroActual = datosDocumento.numero;

        for (const [idProveedor, documentos] of Object.entries(agrupados)) {
          let datosDocumentoNuevoNumero = datosDocumentoNumeroActual;

          // Filtrar relaciones por IdProveedor actual
          const relacionesFiltradas = relacionesDocsCompraPagos.filter(relacion =>
            agrupados[idProveedor].some(doc => doc.IdDocCompra === relacion.IdDocCompra)
          );

          // Modificar datosFormasPago para sumar el importe total de los documentos de este Proveedor
          const importeProveedorTotal = documentos.reduce((total, doc) => total + doc.valorImpPagar, 0);

          let datosFormasPagoModificados = []
          if (DebeCrearAnticipo) {
            datosFormasPagoModificados = datosFormasPago.map((formaPago, index) => ({
              ...formaPago
            }));
          }
          else {
            if (cantidadDeProveedores > 1) {
              datosFormasPagoModificados = datosFormasPago.map((formaPago, index) => ({
                ...formaPago,
                Importe: index === 0 ? importeProveedorTotal : 0, // Solo en la primera forma de pago asignamos el importe total
              }));
            } else {
              datosFormasPagoModificados = datosFormasPago.map((formaPago, index) => ({
                ...formaPago
              }));
            }
          }

          datosFormasPagoModificados = datosFormasPagoModificados.map(item => {
            Object.keys(item).forEach(key => {
              if (key.startsWith("Fecha") && item[key]) {
                item[key] = FormateoFechaPara_yyyyMMdd(new Date(item[key]));
              }
            });

            if (item.IdAnticipoCompra > 0) {
              item.IdAnticipo = item.IdAnticipoCompra;
            }

            return item;
          });

          const numeroFantasiaModificado = `${datosDocumento.codigoPuntoVenta.toString().padStart(4, '0')}-${datosDocumentoNuevoNumero.toString().padStart(8, '0')}`;

          const JSON = await function_COM_Pagos_Generar_JSON(
            0,
            FormateoFechaPara_yyyyMMdd_HHmmss(fecha),
            idProveedor,
            numeroFantasiaModificado,
            datosDocumento.codigoPuntoVenta,
            datosDocumentoNuevoNumero,
            codigoMoneda,
            cotizacion,
            datosConceptoObservaciones.observaciones,
            0,
            0,
            datosFormasPagoModificados,
            datosImpuestos,
            [],
            relacionesFiltradas,
            [] // Ajustar si se necesitan más datos
          );

          const PagoCreado = await function_COM_Pagos_Cabecera_Insertar(JSON, esPagoDeAnticipo, DebeCrearAnticipo)

          alert("Se ha generado el Pago ID: " + PagoCreado.data.codigoGenerado + " - Documento: " + numeroFantasiaModificado)

          datosDocumentoNumeroActual++;
        }
      }

      window.location.reload()
    } catch (error) {
      alert(error)
    } finally {
      setCierreEnProceso(false); // Se habilita el botón de nuevo
    }
  }

  const handleOnTotalImporteDelComponenteChange = (newTotal) => {
    try {
      setImporteEnFormasDePagoTotal(newTotal)
    } catch (error) {
      alert(error)
    }
  };

  const handleOnTotalImporteDelComponenteRetencionesChange = (newTotal) => {
    try {
      setTotalEnImpuestos(newTotal)
    } catch (error) {
      alert(error)
    }
  };

  const getData = async () => {
    setLoading(true)
    try {
      const FechaDesde = new Date()
      FechaDesde.setFullYear(FechaDesde.getFullYear() - 10);
      const FechaHasta = new Date()
      FechaHasta.setFullYear(FechaHasta.getFullYear() + 10);

      const resultData = await function_COM_DocsCompra_Cabecera_ListarPorPagar(await FormateoFechaPara_yyyyMMdd(FechaDesde), await FormateoFechaPara_yyyyMMdd(FechaHasta));
      setData(resultData.data);
    } catch (error) {
      alert("Error al obtener los datos:" + error);
    }
    setLoading(false)
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const datosModificadores = await ObtieneParametros();
        setCodigoMoneda(datosModificadores.GlobalMonedaBase)
        setCodigoMonedaReferente(datosModificadores.GlobalMonedaReferente)

        getData()

        if (props.Codigo.Codigo === "--NUEVO--") {
          setTituloBoton("GUARDAR")
          setAccionBoton("GUARDAR")
        }

        const Terminal = localStorage.getItem("Terminal")
        const resultPuntoFiscal = await function_ABM_IMP_PuntosFiscales_LeerPorTerminal(Terminal, idTipo, 1)

        if (resultPuntoFiscal && resultPuntoFiscal.data && resultPuntoFiscal.data.length > 0) {
          setDatosDocumento({
            codigoPuntoVenta: parseInt(resultPuntoFiscal.data[0].CodigoPuntoFiscal),
            codigoPuntoVentaFormateado: resultPuntoFiscal.data[0].CodigoPuntoFiscal.toString().substring(0, 4).padStart(4, '0'),
          })
        } else {
          setDatosDocumento({
            codigoPuntoVenta: 0,
            codigoPuntoVentaFormateado: "0000"
          })
        }

        setLoading(false);
      } catch (error) {
        alert(error)
      }
    };

    fetchData();
  }, []);

  return (
    <>
      {loading ? (
        <div className="card-body text-center">
          <div className="spinner-border" role="status">
            <span className="sr-only">Cargando...</span>
          </div>
        </div>
      ) : (
        <div>
          <div className="LV-GroupBox-div"
            style={{ marginLeft: '6px', marginRight: '6px', marginBottom: '7px', alignItems: 'center', justifyContent: 'center', gap: '30px' }}>
            <div className="LV-FlexContainer"
              style={{ marginBottom: '10px', marginTop: '10px', alignItems: 'center', justifyContent: 'center', gap: '20px' }}>

              <div style={{ display: 'flex', gap: '5px', alignItems: 'center', justifyContent: 'center', flexGrow: 1 }}>
                Fecha
                <DateBox displayFormat="dd/MM/yyyy" value={fecha} onValueChanged={(e) => setFecha(e.value)} width={120} />

                <div style={{ width: '20px' }}></div>

                <div style={{ width: '70px' }}></div>

                <LVNumberBoxDocumento
                  IdTipo={idTipo}
                  IdTipoMovimiento={idTipoPago}
                  DatosDocumento={datosDocumento}
                  SetDatosDocumento={setDatosDocumento} />

                <div style={{ width: '70px' }}></div>

                <ComboAbmConMonedas onValueChanged={handleOnValueChange_Moneda} value={codigoMoneda} />

                <CheckBox text="ANTICIPO" value={esPagoDeAnticipo} onValueChanged={(e) => setEsPagoDeAnticipo(e.value)} />

                <ComboAbmEexProveedores visible={esPagoDeAnticipo} value={idProveedorSeleccionado} onValueChanged={(e) => setIdProveedorSeleccionado(e.value)} />
              </div>
            </div>
          </div>

          <div className="LV-GroupBox-div" style={{ display: 'flex', height: '550px', marginBottom: '5px', marginTop: '20px', alignItems: 'center', justifyContent: 'center', gap: '50px' }}>
            {data.length > 0 ? (
              <>
                {!esPagoDeAnticipo && (
                  <div style={{ marginTop: '10px', fontWeight: 'bold', gap: '20px' }}>
                    Total Seleccionado: ${totalEnDocumentos.toFixed(2)} - Total Retenciones: ${totalEnImpuestos.toFixed(2)} - Cantidad de Proveedores: {cantidadDeProveedores}

                    <div style={{ height: '20px' }} />

                    <LVGridCarga
                      dataSource={data}
                      id="gridContainer"
                      keyExpr="IdDocCompra"
                      allowDeleting={false}
                      filterRow={true}
                      height={480}
                    >
                      <Column caption="Planta" dataField="CodigoPlanta" width="60" alignment="Left" dataType="string" />
                      <Column caption="Tipo" dataField="COM_DocsCompra_Tipos_Descripcion" width="100" alignment="Left" dataType="string" />
                      <Column caption="Código" dataField="IdDocCompra" width="80" alignment="Right" dataType="number" />
                      <Column caption="Documento" dataField="Factura" width="120" alignment="Left" dataType="string" />
                      <Column caption="Fecha" dataField="Fecha" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />
                      <Column caption="Envío" dataField="FechaEnvio" width="100" alignment="Right" dataType="date" format={'dd/MM/yyyy'} filterOperations={['between']} />
                      <Column caption="Proveedor" dataField="ABM_EEX_Proveedores_RazonSocial" width={"100%"} minWidth="100" alignment="Left" dataType="string" />

                      <Column caption="Imp.Impago" dataField="ImporteImpago" width="100" alignment="Right" dataType="number" />
                      <Column caption="Imp.Pagar" width="100" alignment="Right" dataType="number"
                        cellRender={(data) => (
                          <NumberBox
                            value={valoresNumberBox[data.data.IdItem] || 0}
                            onValueChanged={(e) => handleValueChange(data.data.IdDocCompra, e.value)}
                            onFocusIn={(e) => {
                              const importePorFacturar = data.data.ImporteImpago;
                              e.component.option("value", importePorFacturar); // Copia el valor al NumberBox
                            }}
                            elementAttr={{ class: "dx-theme-accent-as-background-color" }}
                          />
                        )}
                      />
                    </LVGridCarga>
                  </div>
                )}

                <div style={{ width: '1000px', margin: '0px' }}>
                  <LVFormasDePago EsPago={true} ImporteTotal={totalEnDocumentos - totalEnImpuestos} IdEEX={idProveedor}
                    onTotalImporteDelComponenteChange={handleOnTotalImporteDelComponenteChange}
                    datosFormasPago={datosFormasPago}
                    setDatosFormasPago={setDatosFormasPago} />
                </div>
              </>
            ) : (
              <div className="card-body text-center">
                <h5 className="card-title">No hay datos</h5>
              </div>
            )}
          </div>

          <div className="LV-GroupBox-div" style={{ display: 'flex', marginBottom: '5px', marginTop: '20px', alignItems: 'center', justifyContent: 'center', gap: '50px' }}>
            {data.length > 0 ? (
              <>
                <LVButtonAccion Texto={importeRetencionesTotal > 0 ? `RETENCIONES INCLUIDAS` : "RETENCIONES"}
                  onClick={handleOnClick_Retenciones} />
                {showPopupRetenciones ? (
                  <>
                    <LVSelectorRetencionesCompra
                      onConfirm={(datosImpuestos) => handleConfirmRetenciones(datosImpuestos)}
                      onTotalImporteDelComponenteChange={handleOnTotalImporteDelComponenteRetencionesChange}
                      onClose={handleClose_Retenciones}
                      Retenciones={datosImpuestos}
                      ImporteTotal={totalEnDocumentos}
                    />
                  </>
                ) : null}

                <LVButtonAccion Texto="ASIENTO" onClick={handleOnClick_Asiento} />

                <LVButtonAccion Texto="COSTEO" onClick={handleOnClick_Costeo} />

                <LVButtonAccion
                  Disabled={cierreEnProceso} Texto={TituloBoton} onClick={handleOnClick_Guardar} />
              </>
            ) : (
              <div className="card-body text-center">
                <h5 className="card-title">No hay datos</h5>
              </div>
            )}
          </div>
        </div>
      )
      }
    </>
  );
}

export default COM_Pagos;